import { EntityReference, EntityReferenceSchema, EnumSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AllocateFundsDtoSchema = z.object({
    amount: z.number().optional(),
    quote: z.string().optional(),
    entityReference: EntityReferenceSchema.optional(),
    autoTopup: z.boolean().optional(),
    topupCurrency: EnumSchema(Currency).optional(),
});

export class AllocateFundsDto extends FromSchema(AllocateFundsDtoSchema) {
    amount?: number;
    quote?: string;
    entityReference?: EntityReference;
    autoTopup?: boolean;
    topupCurrency?: Currency;
}
